import React, {
  useEffect, useRef, useState, forwardRef,
} from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import AutoNumeric from 'autonumeric';

const AutoNumericInput = forwardRef((props, ref) => {
  const {
    value, onChange, className, size, min, decimalPlaces, style, disabled, autoFocus, id,
  } = props;

  const inputRef = ref || useRef();
  const [autoNumeric, setAutoNumeric] = useState(null);

  useEffect(() => {
    if (autoNumeric) {
      autoNumeric.remove();
    }
    const autonumeric = new AutoNumeric(inputRef.current, value, {
      onFocus: undefined,
      onBlur: undefined,
      onKeyPress: undefined,
      onKeyUp: undefined,
      onKeyDown: undefined,
      watchExternalChanges: true,
      allowDecimalPadding: false,
      decimalPlaces,
      digitGroupSeparator: Number(10000).toLocaleString().substring(2, 3),
      decimalCharacter: parseFloat('1.1').toLocaleString().substring(1, 2),
    });
    setAutoNumeric(autonumeric);
  }, [decimalPlaces, value]);

  return (
    <Input
      innerRef={inputRef}
      id={id}
      className={className}
      disabled={disabled}
      min={min}
      style={style}
      type="input"
      autoFocus={autoFocus}
      bsSize={size}
      onChange={() => onChange(autoNumeric.getNumber())}
    />
  );
});

AutoNumericInput.defaultProps = {
  min: 0,
  value: 0,
  decimalPlaces: 4,
  id: '',
  className: '',
  disabled: false,
  autoFocus: false,
  size: '16',
  style: {},
  onChange: () => undefined,
};

AutoNumericInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.string,
  min: PropTypes.number,
  decimalPlaces: PropTypes.number,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  style: PropTypes.objectOf(PropTypes.any),
};

export default AutoNumericInput;
